/*
 * @description 用于缓存请求结果数据
 * @Author: lentoo
 * @Date: 2019-04-03 14:08:18
 * @Last Modified by: lentoo
 * @Last Modified time: 2019-04-03 15:18:21
 */

export default class Cache {
  constructor (axios, config = {}) {
    this.axios = axios
    this.keys = []
    if (!this.axios) {
      throw new Error('axios is null')
    }
    this.config = config
    this.defaultConfig = {
      cache: false,
      cacheMode: 'sessionStorage',
      expire: 1000 * 60, // 默认过期时间为 60 s
      ...config
    }
    this.CancelToken = this.axios.CancelToken
  }

  setCache (mode = 'sessionStorage', key, value) {
    mode = mode === 'sessionStorage' ? 'sessionStorage' : 'localStorage'
    const storage = window[mode]
    try {
      storage.setItem(key, JSON.stringify(value))
      return true
    } catch (error) {
      console.log('error', `当前环境不支持: ${mode}`)
    }
  }
  getCache (mode = 'sessionStorage', key) {
    mode = mode === 'sessionStorage' ? 'sessionStorage' : 'localStorage'
    const storage = window[mode]
    try {
      const data = storage.getItem(key)
      return JSON.parse(data)
    } catch (error) {
      console.log('error', `当前环境不支持: ${mode}`)
    }
    return ''
  }
  removeCache (mode = 'sessionStorage', key) {
    mode = mode === 'sessionStorage' ? 'sessionStorage' : 'localStorage'
    const storage = window[mode]
    try {
      storage.removeItem(key)
      return true
    } catch (error) {
      console.log('error', `当前环境不支持: ${mode}`)
    }
    return false
  }
  normalizeKey (config) {
    let { url, data, params } = config
    const key = data ? `${url}?cacheParams:${data}` : `${url}?cacheParams=${params}`
    return key
  }
  getCurrentTime () {
    return new Date().getTime()
  }
}
